"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudioPlayback = exports.AudioPlaybackProvider = exports.AudioPlaybackContext = void 0;

var react_1 = __importDefault(require("react"));

exports.AudioPlaybackContext = react_1["default"].createContext(undefined);

function AudioPlaybackProvider(_ref) {
  var children = _ref.children;
  var playingAudioRefs = react_1["default"].useRef([]);
  var value = react_1["default"].useMemo(function () {
    return {
      startPlaying: function startPlaying(element, silenceOthers) {
        if (silenceOthers) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = playingAudioRefs.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var ref = _step.value;

              try {
                ref.pause();
              } catch (_a) {// Oh well, couldn't stop playing it...
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          playingAudioRefs.current = [];
        }

        playingAudioRefs.current.push(element);
        element.currentTime = 0;
        element.play();
      }
    };
  }, []);
  return react_1["default"].createElement(exports.AudioPlaybackContext.Provider, {
    value: value,
    children: children
  });
}

exports.AudioPlaybackProvider = AudioPlaybackProvider;

function useAudioPlayback(url) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$silenceOthers = _ref2.silenceOthers,
      silenceOthers = _ref2$silenceOthers === void 0 ? true : _ref2$silenceOthers,
      modifyAudio = _ref2.modifyAudio;

  var audioRef = react_1["default"].useRef(null);
  react_1["default"].useEffect(function () {
    if (url) {
      audioRef.current = new Audio(url);

      if (modifyAudio) {
        modifyAudio(audioRef.current);
      }
    } else {
      audioRef.current = null;
    }
  }, [url]);
  var context = react_1["default"].useContext(exports.AudioPlaybackContext);
  return function () {
    if (context) {
      if (audioRef.current) {
        context.startPlaying(audioRef.current, silenceOthers);
      }
    } else {
      console.warn('Cannot useAudioPlayback without AudioPlaybackContext');
    }
  };
}

exports.useAudioPlayback = useAudioPlayback;